import axios from "axios";
import useSWR from "swr";

async function fetcher(url) {
  let page = 1;
  let results = [];
  let response, totalPages;
  response = await axios.get(url + '&page=' + page).catch((err) => console.error(err));
  totalPages = response.headers["x-wp-totalpages"];
  results = results.concat(response.data);
  if (page < totalPages) {
    for (let i = page + 1; i <= totalPages; i++) {
      response = await axios.get(url + '&page=' + i).catch((err) => console.error(err));
      results = results.concat(response.data);
    }
  }
  return results;
}

const useStatuses = () => {
  const { data: statuses, error } = useSWR(
    `${window?.__env__?.WP_SOURCE}/wp-json/wp/v2/gpi-statuses?hide_emtpy=true&_fields=id,name`,
    fetcher
  );
  return { statuses, error, loading: !error && !statuses };
};

export default useStatuses;
